import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Board, Departments, UserInterface, GrievanceType } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { AssignedGrievanceViewService } from './assigned-grievance-view.service';

@Component({
  selector: 'app-assigned-grievance-view',
  templateUrl: './assigned-grievance-view.component.html',
  styleUrls: ['./assigned-grievance-view.component.scss'],
})
export class AssignedGrievanceViewComponent implements OnInit {
  myid: any;
  progressSpinnerDialog: any = null;
  protected boards: Board[];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);
  protected _onDestroy = new Subject<void>();

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);


  protected userData: UserInterface[] = [];
  public userCtrl: FormControl = new FormControl();
  public userFilterCtrl: FormControl = new FormControl();
  public filteredUser: ReplaySubject<UserInterface[]> = new ReplaySubject<UserInterface[]>(1);

  firstFormGroup = this._formBuilder.group({
    boardCtrl: ['', [Validators.required]],
    grievanceCtrl: ['', [Validators.required]],
    subjectCtrl: [{ value: null, disabled: true }],
    departmentCtrl: ['', [Validators.required]],
    userCtrl: [null],
    remarkCtrl: [{ value: "null", disabled: true }],
    replyCtrl: ['', [Validators.required]],
  })
  gId: any
  grievanceLevel: any
  protected grievance: GrievanceType[] = [];
  public grievanceCtrl: FormControl = new FormControl();
  public grievanceFilterCtrl: FormControl = new FormControl();
  public filteredGrievance: ReplaySubject<GrievanceType[]> = new ReplaySubject<GrievanceType[]>(1);

  isSubmitDisabled: boolean = false
  boardName: any;
  departmentName: any;
  grievanceType: any;
  lottery: string;
  applicationName: any = null;
  remark: any;
  subject: any;
  depId: any;
  constructor(public _formBuilder: FormBuilder,
    public toastController: ToastController,
    public dialog: MatDialog,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public commonFunction: CommonFunction,
    public assignedGrievanceService: AssignedGrievanceViewService,
  ) { }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  async ngOnInit() {
    //call to load board
    this.gId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceService.loadSingalGrievenceById(this.gId);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        this.grievanceLevel = response.tabUserGrievance.usGriLevel
        this.boards = response.allBoards
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards);
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        response.departments.forEach((value, index) => {
          if (value.key == response.tabUserGrievance.tabDepartment.key) response.departments.splice(index, 1);
        });
        this.departments = response.departments
        this.depId = response.tabUserGrievance.tabDepartment.key
        this.departmentCtrl.setValue(this.departments[10]);
        this.filteredDepartment.next(this.departments.slice());
        this.departmentFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereDepartments();
          })
        this.grievance = response.grievanceTypes;
        this.grievanceCtrl.setValue(this.grievance[10]);
        this.filteredGrievance.next(this.grievance.slice());

        this.grievanceFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereGrievances();
          })
        this.userData = response.tabUsers
        this.userCtrl.setValue(this.userData[10]);
        this.filteredUser.next(this.userData.slice());

        this.userFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filteredUsers();
          })
        this.boardName = response.tabUserGrievance.board.boardName
        this.departmentName = response.tabUserGrievance.tabDepartment.departmentName
        this.grievanceType = response.tabUserGrievance.grievanceTypes.gtGrievanceType
        if (response.tabUserGrievance.lotteryEvent != null) {
          this.lottery = response.tabUserGrievance.lotteryEvent.lotteryName;
        }
        if (response.tabUserGrievance.application != null) {
          this.applicationName = response.tabUserGrievance.application.applicationNo
        }
        this.subject = response.tabUserGrievance.usGriSubject,
          this.remark = response.tabUserGrievance.usGriDetails;

      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }

  protected filteredUsers() {
    if (!this.userData) {
      return;
    }
    let search = this.userFilterCtrl.value;
    if (!search) {
      this.filteredUser.next(this.userData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredUser.next(this.userData.filter(
      item => item.userId.toLowerCase().indexOf(search) > -1)
    )
  }

  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(this.boards.filter(
      item => item.boardName.toLowerCase().indexOf(search) > -1)
    )
  }
  //

  protected filtereGrievances() {
    if (!this.grievance) {
      return;
    }
    let search = this.grievanceFilterCtrl.value;
    if (!search) {
      this.filteredGrievance.next(this.grievance.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGrievance.next(
      this.grievance.filter(grievance => grievance.gtGrievanceType.toLowerCase().indexOf(search) > -1)
    );
  }




  async transferTo() {
    if (this.firstFormGroup.valid) {
      const data = {
        'fkBdid': this.firstFormGroup.controls['boardCtrl'].value,
        'pkUsgrid': this.gId,
        'fkDepid': this.firstFormGroup.controls['departmentCtrl'].value,
        'fkGtid': this.firstFormGroup.controls['grievanceCtrl'].value,
        'usGriOwnerId': this.firstFormGroup.controls['userCtrl'].value,
        'usGriTransferRemark': this.firstFormGroup.controls['replyCtrl'].value,
      }
      this.displayProgressSpinner();
      const response: any = await this.assignedGrievanceService.transferTo(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          await this.commonFunction.successToast(ProjectConstants.transferSuccessmsg, true, "secure/assigned-grievances")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      this.isSubmitDisabled = false
    }
  }

 // select board dependant on grievance type
 async selectBoard(boards: any) {
  this.displayProgressSpinner();
  const response: any = await this.assignedGrievanceService.loadDepartments(boards);
  this.progressSpinnerDialog.close()
  if (response != null && !response.error) {
    this.grievance = [];
    this.departments = []
    this.departmentCtrl.setValue(this.departments[10]);
  this.filteredDepartment.next(this.departments.slice());
  this.departmentFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filtereDepartments();
    })
  this.grievanceCtrl.setValue(this.grievance[10]);
  this.filteredGrievance.next(this.grievance.slice());
  this.grievanceFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filtereGrievances();
    })
    if (response.length != 0) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.departments = response;
        // this.departmentCtrl.setValue(this.departments[10]);
        // this.filteredDepartment.next(this.departments.slice());
        // this.departmentFilterCtrl.valueChanges
        //   .pipe(takeUntil(this._onDestroy))
        //   .subscribe(() => {
        //     this.filtereDepartments();
        //   })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      this.departments = []
      this.grievance = []
    }
  } else {

    await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
  }

  this.departmentCtrl.setValue(this.departments[10]);
  this.filteredDepartment.next(this.departments.slice());
  this.departmentFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filtereDepartments();
    })
  this.grievanceCtrl.setValue(this.grievance[10]);
  this.filteredGrievance.next(this.grievance.slice());
  this.grievanceFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filtereGrievances();
    })
}

  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  async selectDepartment(deptid) {
    if (deptid != 0) {
      this.displayProgressSpinner();
      this.grievance = []
      const response: any = await this.assignedGrievanceService.loadGrievance(deptid, this.firstFormGroup.controls['boardCtrl'].value);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        this.grievance=[]
        if (response.length != 0) {
          if (response[0].status == ProjectConstants.responseStatusSuccess) {
            this.grievance = response;
            this.grievanceCtrl.setValue(this.grievance[10]);
            this.filteredGrievance.next(this.grievance.slice());
            this.grievanceFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtereGrievances();
              })
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
          }
        } else {
         this.grievance=[]
        }

      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
      this.grievanceCtrl.setValue(this.grievance[10]);
      this.filteredGrievance.next(this.grievance.slice());
      this.grievanceFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filtereGrievances();
        })

      this.displayProgressSpinner();
      const data = {
        'depId': deptid,
        'grivLevels': this.grievanceLevel
      };
      const response1: any = await this.assignedGrievanceService.loadUser(data);
      this.progressSpinnerDialog.close()
      if (response1 != null && !response1.error) {
        if (response1[0].status == ProjectConstants.responseStatusSuccess) {
          this.userData = response1;
          this.userCtrl.setValue(this.userData[10]);
          this.filteredUser.next(this.userData.slice());

          this.userFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filteredUsers();
            })
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    }

  }

  // async errorToast() {
  //   await this._snackBar.open(ProjectConstants.networkErMsg,
  //     "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   });
  // }
}




